import React from "react";
import {
  Card,
  Typography,
  Stack,
  Box,
  Button,
} from "@mui/material";

import LinesEllipsis from 'react-lines-ellipsis'

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AddIcon from '@mui/icons-material/Add';


import { useNavigate } from 'react-router-dom';
import { useTheme } from "@mui/styles";
import { ReactComponent as ProductIcon } from '../../assets/icons/product.svg';
import { ReactComponent as ExchangeIcon } from '../../assets/icons/exchange.svg';


const products = [
  {name: 'Business Term Loan (streamlined)', link:'/products/business-term-loan', description: 'Business Term Loans are a type of financing that provides a lump sum of money to a business that is repaid in fixed monthly payments over a set period of time. Business Term Loans are typically used to finance large purchases, such as equipment, vehicles, or real estate. Business Term Loans are available for up to $5 million, and can be used for a variety of business purposes, including working capital, equipment, and real estate.'},
  {name: 'SBA 7(a)', link:'/products/business-term-loan', description: 'SBA 7(a) loans are the most common type of SBA loan. They are available to businesses that are unable to obtain financing on reasonable terms through conventional lending channels. SBA 7(a) loans are available for a variety of business purposes, including working capital, equipment, and real estate. SBA 7(a) loans are available for up to $5 million, and can be used for a variety of business purposes, including working capital, equipment, and real estate.'},
  {name: 'Line of Credit'},
  {name: 'CRE'},
  {name: 'SBA 504', exchange: true, description: 'SBA 504 loans are available to businesses that are unable to obtain financing on reasonable terms through conventional lending channels. SBA 504 loans are available for a variety of business purposes, including working capital, equipment, and real estate. SBA 504 loans are available for up to $5 million, and can be used for a variety of business purposes, including working capital, equipment, and real estate.'},
  {name: 'Working Capital', exchange: true}, 
  {name: 'Equipment Financing', exchange: true, description: 'Equipment Financing is a type of financing that provides a lump sum of money to a business that is repaid in fixed monthly payments over a set period of time. Equipment Financing is typically used to finance large purchases, such as equipment, vehicles, or real estate. Equipment Financing is available for up to $5 million, and can be used for a variety of business purposes, including working capital, equipment, and real estate.'},
];

export default function Product() {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box p={4} width="100%">
      <Card sx={{  borderRadius: "15px" }} elevation={0} >
        <Stack  p={4} spacing={4}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="h4">
                API Portal
              </Typography>
              {/* <MenuButton/> */}
              <Button startIcon={<AddIcon/>} onClick={() => navigate('/products/add-product') } variant="outlined">Add Product</Button>
          </Stack>

          <Stack spacing={2}>
            {products.map((product, index) => (
              <Card elevation={0} m={4} key={index}
                    sx={{ height: "100%", borderRadius: "15px", border: 1, borderColor: 'grey.300', cursor: product.link ? 'pointer' : 'default' }}
                    onClick={() => {product.link && navigate(product.link)} }>
                <Stack container justifyContent="space-between" direction="row" spacing={0} m={2} alignItems="center" >
                  <Stack direction="row" alignItems={'center'} spacing={2}  width="80%">
                    {product.exchange ? <ExchangeIcon /> : <ProductIcon/> }
                    {/* <Stack direction="row" alignItems={'center'} spacing={2}>  */}
                    <Stack direction="column">
                      <Typography variant="h6" whiteSpace={'nowrap'}>{product.name}</Typography>
                      {product.description &&
                      <Typography variant="body2" color="grey.500">
                        <LinesEllipsis maxLine='1' text={product.description?.substring(0, 100)} />
                      </Typography>}
                    </Stack>
                  </Stack>
                  <Button>
                    <ArrowForwardIcon/>
                  </Button>
                </Stack>
              </Card>
            ))}
          </Stack>
        </Stack>
      </Card>
    </Box>
  );
}
